"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const CheckBoxCell_1 = require("../../../elements/CheckBoxCell");
const IsotopesViewer_1 = __importDefault(require("../../../elements/IsotopesViewer"));
const ReactTable_1 = __importDefault(require("../../../elements/ReactTable/ReactTable"));
function OnLoadProcessingTabContent() {
    const { values } = (0, formik_1.useFormikContext)();
    const [activeTab, setActiveTab] = (0, react_1.useState)('1H');
    const tabItems = Object.keys(values?.onLoadProcessing || {}).map((nucleus) => ({
        id: nucleus,
        title: (0, jsx_runtime_1.jsx)(IsotopesViewer_1.default, { value: nucleus }),
        content: ((0, jsx_runtime_1.jsx)(FiltersTable, { data: values?.onLoadProcessing?.[nucleus], nucleus: nucleus })),
    }));
    return ((0, jsx_runtime_1.jsx)("div", { style: { width: '100%', overflow: 'hidden' }, children: (0, jsx_runtime_1.jsx)(ui_1.Tabs, { items: tabItems, opened: activeTab, onClick: (id) => setActiveTab(id) }) }));
}
function FiltersTable({ data, nucleus }) {
    const COLUMNS = [
        {
            index: 1,
            Header: '#',
            accessor: (_, index) => index + 1,
        },
        {
            index: 1,
            Header: 'Filter',
            accessor: 'label',
            style: { width: '60%' },
        },
        {
            index: 2,
            Header: 'Enable',
            Cell: ({ row }) => ((0, jsx_runtime_1.jsx)(CheckBoxCell_1.CheckBoxCell, { name: `onLoadProcessing.${nucleus}.${row.index}.flag`, defaultValue: false })),
        },
    ];
    return (0, jsx_runtime_1.jsx)(ReactTable_1.default, { columns: COLUMNS, data: data });
}
exports.default = OnLoadProcessingTabContent;
